import React, { FunctionComponent, useEffect } from 'react';
import { useModalToggle } from '../../hooks/useModalToggle';
import EncourageDonateModal from './EncourageDonateModal';
import useAbEnrol from '../../hooks/useAbEnrol';

const EncourageDonateModalContainer: FunctionComponent = () => {
  const { setOpen, isOpen, ref, Portal } = useModalToggle();
  const storageKey = 'isEncourageDonatePromptDismissed';
  const closeModal = () => {
    localStorage.setItem(storageKey, String(true));
    setOpen(false);
  };
  const { enrolledInVariation } = useAbEnrol(
    'fr_growth_encourage_share_time_30_seconds',
  );
  useEffect(() => {
    const userHasDismissed = localStorage.getItem(storageKey) === String(true);

    if (userHasDismissed) {
      return;
    }

    if (enrolledInVariation) {
      const isEnrolledIn30SecondsModal = enrolledInVariation === 'B';
      const timeoutInMs = isEnrolledIn30SecondsModal ? 30000 : 40000;

      const timer = global.setTimeout(() => {
        setOpen(true);
      }, timeoutInMs);

      return () => clearTimeout(timer);
    }
  }, [setOpen, enrolledInVariation]);

  return (
    <>
      {isOpen && (
        <Portal background focusLock scrollLock onClose={closeModal}>
          <EncourageDonateModal ref={ref} onClose={closeModal} />
        </Portal>
      )}
    </>
  );
};

export default EncourageDonateModalContainer;
